import { toast } from '@Shelly/shelly-design-system';
import { control_bluetooth_device_android } from 'src/services/native_container_requests_android';
import {
	control_bluetooth_device_ios,
	hapticFeedback,
} from 'src/services/native_container_requests_ios';
import { devices } from 'src/stores/lists/devices';
import { os } from 'src/stores/session/native-bridge';
import { hideBluetoothSettingsToast } from 'src/stores/ui/calibration-modals';
import {
	controlBleDevice,
	showBleControlSetupModal,
	suppressBleControlSetupModal,
	suppressBleSessionTeardownAlerts,
} from 'src/stores/features/ble/control-device';
import { format } from 'svelte-i18n';
import { get } from 'svelte/store';
import { capFirstChar } from './utilities';
import { is_GBLE, real_id } from './interface_helpers';
import { bulkUpdate } from 'src/components/DevicesSettings/ApplicationSettings/app_settings_helper';

//Alex: will refactor and abstract fo use in inclusion after the dev process is done and the logic is set in stone...
export const status_keys = {
	buttonPressRequired: 'button_press_required', //0
	deviceAcquired: 'device_acquired', //1
	deviceProcessed: 'device_processed', //2
	device: 'device', //3
	pairingModeRequired: 'pairing_mode_required', //4
	pairingWithDevice: 'pairing_with_device', //5
	deviceOtaRequired: 'device_ota_required', //6
	deviceOtaAvailable: 'device_ota_available', //7
	version: 'version', //8
	current: 'current', //9
	discoveringDevices: 'discovering_devices', //10
	encryptingDevice: 'encrypting_device', //11
	deviceEncrypted: 'device_encrypted', //12
	passkey: 'passkey', //13
	deviceAlreadyEncrypted: 'device_already_encrypted', //14
	requestPasskeyFromUser: 'request_passkey_fromUser', //15
	gettingDeviceInformation: 'getting_device_information', //16
	gettingDeviceInfo: 'getting_device_info', //17
	searchingShellyDevice: 'searching_shelly_device', //18
	connectingToDevice: 'connecting_to_device', //19
	connectedToDevice: 'connected_to_device', //20
	disconnectedFromDevice: 'disconnect_from_device_ios', //21
	gettingStatus: 'getting_status', //22
	gettingSettings: 'getting_settings', //23
	turningCloudOn: 'turning_cloud_on', //24
	includingInWiFi: 'including_in_wifi', //25
	checkFWVersion: 'check_FW_version', //26
	fwUpdated: 'fw_updated', //27
	passwordSet: 'password_set', //28
	configuringDevice: 'configuring_device', //29
	otaProgress: 'ota_progress', //30
	progress: 'progress', //31
	beaconStateChanged: 'beacon_state_changed', //32
	buzzerStateChanged: 'buzzer_state_changed', //33
	pairingDenied: 'pairing_denied', //34
	userHoldingButton: 'user_holding_button', //35
	accessPointDisabled: 'access_point_disabled', //36
	bluetoothDisabled: 'bluetooth_disabled', //37
	enabled: 'enabled', //38
	deviceAdvDataChanged: 'device_adv_changed', //39
	requestDigestPasswordFromUser: 'request_digest_password_from_user', //40//gen2 only locked device response will be command=include&pass(a-z,A-Z,0-9)//ToDo implement it
	buzzerPlayStateChanged: 'buzzer_play_state_changed', //41
	decryptingDevice: 'decrypting_device', //42
	deviceDecrypted: 'device_decrypted', //43
	buzzerTurnedOn: 'buzzer_turned_on', //44
	buzzerTurnedOff: 'buzzer_turned_off', //45
	beaconEnabled: 'beacon_enabled', //46
	beaconDisabled: 'beacon_disabled', //47
	buzzerEnabled: 'buzzer_enabled', //48
	buzzerDisabled: 'buzzer_disabled', //49
	deviceOtaCompleted: 'device_ota_completed', //50
	motionLedEnabled: 'motion_led_enabled', //51
	motionLedDisabled: 'motion_led_disabled', //52
	blindTimeSet: 'blind_time_set', //53
	sensitivitySet: 'sensitivity_set', //54
	digestPasswordSet: 'digest_password_set', //55
	scanningWiFi: 'scanningWiFi', //56
	distanceRangeSet: 'distance_range_set', //57
	intervalMeasureSet: 'interval_measure_set', //58
	measureVibrationEnabled: 'measure_vibration_enabled', //59
	measureVibrationDisabled: 'measure_vibration_disabled', //60
	minAngleThresholdSet: 'min_angle_threshold_set', //61
	utcOffsetSet: 'utc_offset_set', //62
	temperatureOffsetSet: 'temperature_offset_set', //63
	humidityOffsetSet: 'humidity_offset_set', //64
	darkThresholdSet: 'dark_threshold_set', //65
	brightThresholdSet: 'bright_threshold_set', //66
	invertDisplayEnabled: 'invert_display_enabled', //67
	invertDisplayDisabled: 'invert_display_disabled', //68
	fahrenheitEnabled: 'farenheit_enabled', //69
	fahrenheitDisabled: 'farenheit_disabled', //70
	clockSyncEnabled: 'clock_sync_enabled', //71
	clockSyncDisabled: 'clock_sync_disabled', //72
	powerSaverEnabled: 'power_saver_enabled', //73
	powerSaverDisabled: 'power_saver_disabled', //74
	zigbeeEnabled: 'zigbee_enabled', //75
	zigbeeDisabled: 'zigbee_disabled', //76
	smokeThresholdSet: 'smoke_threshold_set', //77
	temperatureThresholdSet: 'temperature_threshold_set', //78
	fireGroupSet: 'fire_group_set', //79
	clockModeSet: 'clock_mode_set', //80
};

export const error_keys = {
	noDevicesFound: 'no_devices_found', //0
	deviceNotFound: 'device_not_found', //1
	cantConnectToWiFi: 'cant_connect_to_wifi', //2
	cantGetDeviceInfo: 'cant_get_device_info', //3
	cantGetDeviceStatus: 'cant_get_device_status', //4
	cantGetDeviceSettings: 'cant_get_device_settings', //5
	cantTurnCloudOn: 'cant_turn_cloud_on', //6
	userDenied: 'user_cancelled_operation', //7
	invalidInclusionError: 'invalid_inclusion_error', //8
	cantConnectToBluetooth: 'cant_connect_to_bluetooth', //9
	unpairDeviceRequired: 'unpair_device_required', //10
	connectionTimeout: 'connection_timeout', //11
	fwUpdateFailed: 'fw_update_failed', //12
	cantSetPassword: 'cant_set_password', //13
	invalidJWTToken: 'invalid_jwt_token', //14,
	pairingDenied: 'pairing_denied', //15
	cantChangeBeaconState: 'cant_change_beacon_state', //16
	cantChangeBuzzerState: 'cant_change_buzzer_state', //17
	deviceLost: 'device_lost', //18
	invalidInclusionURLError: 'invalid_inclusion_url_error', //19
	scanTimeout: 'scan_timeout', //20
	cantEncryptDevice: 'cant_encrypt_device', //21
	cantDecryptDevice: 'cant_decrypt_device', //22
	missingEncKey: 'missing_enc_key', //23
	bondingFailed: 'bonding_failed', //24
	failedToSetBlindTime: 'failed_blind_time_set', //25
	failedToSetSensitivity: 'failed_sensitivity_set', //26
	cantChangeMotionLedState: 'failed_motion_led_set', //27
	authenticationError: 'authentication_error', //28
	failedToSetDistanceRange: 'failed_to_set_distance_range', //29
	failedToSetMeasureInterval: 'failed_to_set_measure_interval', //30
	cantChangeMeasureVibrationState: 'cant_change_measure_vibration_state', //31
	failedToSetMinAngleThreshold: 'failed_to_set_min_angle_threshold', //32
	failedToSetUtcOffset: 'failed_to_set_utc_offset', //33'
	failedToSetTemperatureOffset: 'failed_to_set_temperature_offset', //34
	failedToSetHumidityOffset: 'failed_to_set_humidity_offset', //35
	failedToSetDarkThreshold: 'failed_to_set_dark_threshold', //36
	failedToSetBrightThreshold: 'failed_to_set_bright_threshold', //37
	cantChangeInvertDisplayState: 'cant_change_invert_display_state', //38
	cantChangeFahrenheitState: 'cant_change_fahrenheit_state', //39
	cantChangeClockSyncState: 'cant_change_clock_sync_state', //40
	cantChangePowerSaverState: 'cant_change_power_saver_state', //41
	cantChangeZigbeeState: 'cant_change_zigbee_state', //42
	cantChangeClockMode: 'cant_change_clock_mode', //43
};

export function bleControlHandler(nativeLayerData) {
	const _format = get(format);
	const timeStamp = new Date().getTime();
	const parsed_data: {
		settings?;
		status?;
		discovered_ble_devices?;
		error?;
		errors?;
		device?;
		progress?;
		version?;
		current?;
	} = JSON.parse(nativeLayerData);

	console.log('mobile.controling_device', parsed_data);

	controlBleDevice.updateControlStatus(
		parsed_data.status,
		Object.keys(status_keys).indexOf(parsed_data.status),
		status_keys[parsed_data.status],
		error_keys[parsed_data.error],
		Object.keys(error_keys).indexOf(parsed_data.error),
		timeStamp,
		parsed_data?.device?.settings?.encryptionKey,
	); //passing encryption key and then to finalize process
	const controlBleDeviceState = get(controlBleDevice);
	if (parsed_data?.status) {
		// update Status

		const controlBleDeviceState = get(controlBleDevice);

		switch (controlBleDeviceState.currentStatusIndex) {
			case -1:
				// BT is turned off
				controlBleDevice.updateProcessRunning(false);
				break;
			case 0:
				controlBleDevice.updateSearchingState(true);
				break;
			case 2:
				controlBleDevice.updateSearchingState(false);

				// controlBleDevice.updateConnectionState(0);
				const { id, mac, fwID, fwLatest } = parsed_data.device.info;

				// const { type } = get(devices)[id];
				// const newFwVersion = get(firmwares_gen_gble)[type]?.version;

				const {
					beaconEnabled,
					buzzerEnabled,
					encrypted,
					encryptionKey,
					blindTime,
					motionBlindTime,
					motionSensitivity,
					motionLedEnabled,
					invertDisplayEnabled,
					fahrenheitEnabled,
					clockSyncEnabled,
					powerSaverEnabled,
					zigbeeEnabled,
					minAngleThreshold,
					distanceRange,
					measureInterval,
					measureVibration,
					clockFormat,
				} = parsed_data.device.settings;

				const deviceObject = {
					...get(devices)[id],
					beaconEnabled,
					buzzerEnabled,
					blindTime: blindTime || motionBlindTime,
					motionSensitivity,
					motionLedEnabled,
					invertDisplayEnabled,
					fahrenheitEnabled,
					clockSyncEnabled,
					powerSaverEnabled,
					zigbeeEnabled,
					minAngleThreshold,
					distanceRange,
					measureInterval,
					measureVibration,
					clockFormat,
					encrypted,
					fwID,
					key_enc: encryptionKey,
					mac,
				};

				const cleanedDevice = Object.fromEntries(
					Object.entries(deviceObject).filter(([_, value]) => value !== undefined),
				);

				bulkUpdate(id, cleanedDevice);

				const semVer = /\d+(\.\d+){2,}/gi;

				const hasUpdate =
					fwLatest && fwID?.match(semVer)?.toString() !== fwLatest?.match(semVer)?.toString();
				controlBleDevice.updateHasFWUpdateState(hasUpdate, fwLatest);
				controlBleDevice.updateDeviceId(id);

				break;
			case 4: {
				/**
				 * `pairingModeRequired` triggers the GBLE-style "press device
				 * button for 10 seconds" modal — its message is built from
				 * `pairingMessageWrapper(realDevice.type, …)`, which is only
				 * meaningful for battery-button GBLE devices. For mains-
				 * powered Gen2 devices the bonding flow is driven by cloud
				 * RPC (`Ble.StartPairing`), and the OS surfaces its own
				 * native pair prompt, so this modal would just flash on
				 * screen with the wrong instructions before the surface
				 * (e.g. the Bluetooth RPC tester) takes over.
				 *
				 * Gate on device type first (only show for GBLE), then keep
				 * the existing `suppressBleControlSetupModal` opt-out for
				 * GBLE surfaces that still want to drive their own UI.
				 */
				const targetDevice = get(devices)[real_id(controlBleDeviceState.deviceId)];
				if (is_GBLE(targetDevice) && !get(suppressBleControlSetupModal)) {
					showBleControlSetupModal.set('pair');
				}
				break;
			}
			case 7: {
				// `deviceOtaAvailable` is an idle decision point — the BLE session
				// isn't doing work while we wait on the user — so clear the process
				// flag. This keeps the device settings usable and lets the update
				// modal distinguish "waiting for confirmation" from "initializing".
				controlBleDevice.updateProcessRunning(false);

				// The native layer fires `deviceOtaAvailable` even when the device is
				// already on the latest firmware (version === current). Only surface
				// the update prompt when a genuinely newer build is offered.
				const semVer = /\d+(\.\d+){2,}/gi;
				const availableVersion = parsed_data.version?.match(semVer)?.toString();
				const installedVersion = parsed_data.current?.match(semVer)?.toString();
				const alreadyUpToDate =
					!!availableVersion && !!installedVersion && availableVersion === installedVersion;

				if (!alreadyUpToDate) {
					showBleControlSetupModal.set('update');
				}
				break;
			}
			case 18:
				controlBleDevice.updateSearchingState(true);
				break;
			case 19:
				if (get(os) === 'IOS') {
					hapticFeedback('general');
				}
				controlBleDevice.updateSearchingState(false);
				controlBleDevice.updateConnectionState(1);
				break;
			case 20:
				if (get(os) === 'IOS') {
					hapticFeedback('success');
				}
				showBleControlSetupModal.set(undefined);
				controlBleDevice.updateSearchingState(false);
				controlBleDevice.updateConnectionState(2);
				// Clear any leftover OTA progress so a post-update reconnect doesn't
				// reopen the update modal in a stale "press device button" state.
				controlBleDevice.updateFWUpdateProgressState(0);
				break;
			case 21:
				// Fails to connect or disconnects
				controlBleDevice.updateProcessRunning(false);
				controlBleDevice.updateSearchingState(false);
				controlBleDevice.updateConnectionState(0);
				break;
			case 30:
				showBleControlSetupModal.set('update');
				controlBleDevice.updateFWUpdateProgressState(parsed_data.progress);

				// Android does not send event index 50 so we assume fw update is successful when progress is 100
				if (get(os) !== 'IOS' && parsed_data.progress === 100) {
					toast.open({
						type: 'success',
						title: capFirstChar(
							_format('progress_state_update_complete', {
								default: 'Update complete',
							}),
						),
						text: _format('device_is_updated', {
							default: 'Your device is up to date.',
						}),
					});
				}
				break;

			case 50:
				// `deviceOtaCompleted` — the OTA has finished and the device is
				// rebooting. Reconnect so the settings screen refreshes with the new
				// firmware version and current state; the modal is dismissed by
				// `connectedToDevice` (case 20) once the link is re-established. The
				// modal stays in its "press device button" state until then.
				if (controlBleDeviceState.deviceId) {
					get(os) === 'IOS'
						? control_bluetooth_device_ios(controlBleDeviceState.deviceId, 'connect')
						: control_bluetooth_device_android(controlBleDeviceState.deviceId, 'connect');
				}
				// Android already surfaces the completion toast in case 30 when
				// `progress === 100`; only toast here for iOS to avoid a duplicate.
				if (get(os) === 'IOS') {
					toast.open({
						type: 'success',
						title: capFirstChar(
							_format('progress_state_update_complete', {
								default: 'Update complete',
							}),
						),
						isTitleBold: true,
						text: capFirstChar(
							_format('device_is_updated', {
								default: 'Your device is up to date.',
							}),
						),
					});
				}
				break;
			case 53: // blind_time_set
			case 54: // sensitivity_set
			case 57: // distance_range_set
			case 58: // interval_measure_set
			case 61: // min_angle_threshold_set
			case 62: // utc_offset_set
			case 63: // temperature_offset_set
			case 64: // humidity_offset_set
			case 65: // dark_threshold_set
			case 66: // bright_threshold_set
			case 77: // smoke_threshold_set
			case 78: // temperature_threshold_set
			case 79: // fire_group_set
			case 80: // clock_mode_set
				if (!get(hideBluetoothSettingsToast)) {
					toast.open({
						type: 'success',
						title: get(format)('setting_scc_saved_toast', {
							default: 'Setting saved successfully.',
						}),
					});
				}
			default:
				break;
		}
	}

	if (parsed_data?.error && error_keys[parsed_data.error]) {
		switch (controlBleDeviceState.currentErrorIndex) {
			case -1:
				controlBleDevice.updateProcessRunning(false);

				toast.open({
					type: 'danger',
					title: capFirstChar(_format(error_keys[parsed_data.error])),
				});
				break;
			case 10:
				/**
				 * `unpairDeviceRequired` — the native bridge surfaces this
				 * whenever the next bond would require the user to forget
				 * the device from system Bluetooth settings first. Surfaces
				 * that *expect* this as a side-effect of completing a
				 * one-shot operation (e.g. the Bluetooth RPC tester, where
				 * every successful BRPC frame leaves the link in this state
				 * by design) opt out via `suppressBleSessionTeardownAlerts`
				 * so we don't force-disconnect the session or surface a
				 * toast the user can't act on inline.
				 */
				showBleControlSetupModal.set(undefined);
				controlBleDevice.updateProcessRunning(false);
				if (get(suppressBleSessionTeardownAlerts)) {
					break;
				}
				if (controlBleDeviceState.deviceId) {
					get(os) === 'IOS'
						? control_bluetooth_device_ios(controlBleDeviceState.deviceId, 'disconnect')
						: control_bluetooth_device_android(controlBleDeviceState.deviceId, 'disconnect');
				}
				toast.open({
					type: 'danger',
					title: _format(`toast_title_unpair_device_required`, {
						default: 'Un-pair device required',
					}),
					text: _format('toast_text_unpair_device_required', {
						default:
							'Please un-pair your device from the list of paired bluetooth devices from your iOS Settings: Bluetooth/Shelly Device/Forget This Device.',
					}),
				});
				break;
			case 24:
				/**
				 * `bondingFailed` — fires when re-bonding after a one-shot
				 * operation can't complete (commonly the second step of
				 * the post-BRPC teardown cascade that follows
				 * `unpairDeviceRequired` on FW ≥2.0.0). Same opt-out as
				 * case 10 above: surfaces that own their session lifecycle
				 * can suppress the force-disconnect + danger toast via
				 * `suppressBleSessionTeardownAlerts`.
				 */
				showBleControlSetupModal.set(undefined);
				controlBleDevice.updateProcessRunning(false);
				if (get(suppressBleSessionTeardownAlerts)) {
					break;
				}
				if (controlBleDeviceState.deviceId) {
					get(os) === 'IOS'
						? control_bluetooth_device_ios(controlBleDeviceState.deviceId, 'disconnect')
						: control_bluetooth_device_android(controlBleDeviceState.deviceId, 'disconnect');
				}
				toast.open({
					type: 'danger',
					title: _format(`toast_title_bonding_failed`, {
						default: 'Bonding failed ',
					}),
					text: _format('toast_text_bonding_failed', {
						default: 'Please try again, if the issue is not resolved reset the device.',
					}),
				});
				break;
			default:
				controlBleDevice.updateProcessRunning(false);

				toast.open({
					type: 'danger',
					title: capFirstChar(_format(error_keys[parsed_data.error])),
				});
				break;
		}
	}

	// console.log('controlBleDeviceState', get(controlBleDevice));

	return { isok: true };
}
